import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import StyledBadge from './badge.style';
export const Badge = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    appearance = undefined,
    className = 'badge',
    max,
    value = 0
  } = props;
  return _jsx(StyledBadge, _extends({
    className: className,
    role: "status",
    ref: ref,
    appearance: appearance,
    max: max,
    value: value
  }, {
    children: value !== undefined && value !== null && _jsx("span", {
      children: max && Number(value) > max && appearance !== 'removed' ? "".concat(max, "+") : "".concat(appearance === 'added' ? '+' : appearance === 'removed' ? '-' : '', " ").concat(value)
    })
  }));
});
export default Badge;